import { getEndpoints } from "../../Lib/Config/EndPoints/EndPoints";
import { apiRequest } from "../../Lib/Utils/ApiRequest";
import { IApiResponse } from "../../Orchestrator/Types/Index";
import { ITiersConfig } from "../../Orchestrator/Types/Interface/ICustomerTiers";

export async function getTiersConfig(): Promise<IApiResponse<ITiersConfig>> {
  const ENDPOINTS = await getEndpoints();
  const endpoint = ENDPOINTS.getTiersConfig;
  // Defense-in-depth: tiersConfigAtom is the primary session cache (see
  // getCachedTiersConfig). 'classic' here also caches at the apiRequest layer
  // so any direct caller still benefits.
  return await apiRequest<ITiersConfig>(endpoint, "GET", {}, "classic");
}
